module.exports = __webpack_public_path__ + "static/media/authorization-code-grant.eaf3e67a.jpg";